import { render, staticRenderFns } from "./HandOrange.vue?vue&type=template&id=c6f707dc&scoped=true&"
var script = {}
import style0 from "./HandOrange.vue?vue&type=style&index=0&id=c6f707dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f707dc",
  null
  
)

export default component.exports